const CONSTANTS = {
  ROUTES: {
    GUEST_HOME: '/auth/login',
    ADMIN_HOME: '/admin/user-list',
  } as const,
} as const;

export default CONSTANTS;
